var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSyncGradient = function SvgSyncGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#syncGradient_svg__a)",
    fillRule: "evenodd",
    d: "M12 3.75a8.23 8.23 0 0 0-6.197 2.803L7.61 8.36a.375.375 0 0 1-.265.64h-5.47a.375.375 0 0 1-.375-.375v-5.47c0-.334.404-.501.64-.265l2.07 2.07A10.47 10.47 0 0 1 12 1.5c5.373 0 9.803 4.035 10.425 9.241a1.125 1.125 0 1 1-2.234.268A8.25 8.25 0 0 0 12 3.75m-9.442 8.258a1.125 1.125 0 0 1 1.25.983 8.252 8.252 0 0 0 14.389 4.456L16.39 15.64a.375.375 0 0 1 .265-.64h5.47c.207 0 .375.168.375.375v5.47a.375.375 0 0 1-.64.265l-2.07-2.07A10.47 10.47 0 0 1 12 22.5c-5.373 0-9.803-4.035-10.425-9.241a1.125 1.125 0 0 1 .983-1.251",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "syncGradient_svg__a",
    x1: 12,
    x2: 12,
    y1: 1.5,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#389CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B00DE"
  })))));
};
export default SvgSyncGradient;